/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */

import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  //Date range picker Component
  open: () => _t(translations.dateRangePicker.open),
  openDate: () => _t(translations.dateRangePicker.openDate),
  renewalDate: () => _t(translations.dateRangePicker.renewalDate),
  cancel: () => _t(translations.dateRangePicker.cancel),
  Apply: () => _t(translations.dateRangePicker.apply),
};
